import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import { FormattedMessage } from 'react-intl';

import messages from '../../messages';
import Button from '../../../components/Button/Button';

export default function InvalidBSBWarning(props) {
  const { isOpen, onClose } = props;
  return (
    <Modal style={customStyles} ariaHideApp={false} isOpen={isOpen}>
      <div className={'no-benefit-modal'} />
      <div id="full_description">
        <div
          className="justify-content-between"
          style={{
            textAlign: 'justify',
            fontSize: 18,
          }}
        >
          <p>
            <FormattedMessage {...messages.invalidBSBWarning} />
          </p>
        </div>
      </div>
      <div className="row justify-content-center mt-10">
        <div className="col-auto">
          <Button
            backgroundColor="#44b4a6"
            hoverBackgroundColor="#3e9e92"
            padding="13px 25px"
            borderRadius="8px"
            borderColor="transparent"
            fontSize="1em"
            onClick={onClose}
          >
            OK
          </Button>
        </div>
      </div>
    </Modal>
  );
}

InvalidBSBWarning.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
};

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: '#ffedee',
    color: '#ff0000',
    width: '80%,',
    textAlign: 'left',
    borderRadius: 5,
    borderWidth: 2,
    borderStyle: 'solid',
    borderColor: '#b4b4b4',
    minWidth: 400,
    overflow: 'visible',
    maxWidth: 800,
  },
  overlay: {
    backgroundColor: 'rgba(0,0,0,.75)',
  },
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Appsure.StepBankDetails/components/InvalidBSBWarning/index.js